import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/shared/service/auth.service';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { PlanService } from 'src/app/shared/service/plan.service';

@Component({
  selector: 'app-register-callback',
  templateUrl: './register-callback.component.html',
  styleUrls: ['./register-callback.component.scss']
})
export class RegisterCallbackComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NotificationService,
    private translate: TranslateService,
    private planService: PlanService
  ) {}

  ngOnInit(): void {
    console.log('RegisterCallbackComponent initialized');
    console.log('Current URL:', window.location.href);
    
    // Get the authorization code and state from the URL parameters
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const error = this.route.snapshot.queryParamMap.get('error');
    const errorDescription = this.route.snapshot.queryParamMap.get('error_description');

    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];
    const slug = this.planService.getTheSlug(subdomain);

    console.log('Registration callback parameters:', { code, state, error });

    if (error) {
      console.error('Auth0 registration callback error:', error, errorDescription);
      this.handleError(errorDescription || error);
      return;
    }

    if (!code || !state) {
      console.error('Missing required callback parameters');
      this.handleError('Invalid callback parameters');
      return;
    }

    // // Validate state matches what we stored
    // const storedState = localStorage.getItem('registrationState');
    // if (storedState !== state) {
    //   console.error('State mismatch in registration callback');
    //   this.handleError('Invalid or expired registration session');
    //   return;
    // }

    // Call the backend to complete the registration
    this.authService.completeRegistration(code, state, slug).subscribe({
      next: (result) => {
        // Clean up stored state
        localStorage.removeItem('registrationState');
        
        // Show success message
        this.notification.showSuccessMessage(
          this.translate.instant('REGISTRATION_SUCCESSFUL')
        );
        
        // Redirect to success page with member ID
        this.router.navigate(['/registration-success'], {
          queryParams: { memberId: result.memberId }
        });
      },
      error: (error) => {
        console.error('Registration completion failed:', error);
        this.handleError(error.error?.message || error.message || 'Registration failed');
      }
    });
  }

  private handleError(message: string): void {
    // Clean up stored state
    localStorage.removeItem('registrationState');
    
    // Show error message
    this.notification.showErrorMessage(message);
    
    // Redirect back to join page
    this.router.navigate(['/join']);
  }
}